import { render, staticRenderFns } from "./PreciosActualizadosEnTabla.vue?vue&type=template&id=9ddd1eb4&"
import script from "./PreciosActualizadosEnTabla.vue?vue&type=script&lang=js&"
export * from "./PreciosActualizadosEnTabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports